import { Box, Stack, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useSelector } from "react-redux";

const NoAdjDetect = () => {
  const brandDisplayName = useSelector(
    (state: any) => state?.deepView?.deepViewData?.period?.brand_display_name,
  );

  return (
    <>
      <Box
        sx={{
          border: "1px solid #2E7D3280",
          borderRadius: "8px",
          backgroundColor: "#2E7D320A",
          p: 1,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <CheckIcon
            sx={{
              color: "#1B5E20",
              fontSize: 18,
            }}
          />

          <Typography
            sx={{
              color: "#1B5E20",
              fontSize: "14px",
              fontWeight: 500,
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            No Manual Adjustments
          </Typography>
        </Stack>

        <Typography
          sx={{
            color: "#1B5E20",
            fontSize: "14px",
            lineHeight: "20px",
          }}
        >
          No manual adjustments were applied to{" "}
          <strong>{brandDisplayName}</strong> in Sport for the selected period.
          The <strong>manual_chng_history</strong> field is empty or -1. The
          value passed through from fraud correction to the final table
          unchanged.
        </Typography>
      </Box>
    </>
  );
};

export default NoAdjDetect;
